module.exports = __webpack_public_path__ + "media/images/farmer_flowers-202aa5518676c2da9acac5138a8dd72c.jpg";